import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = ["title"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_v_data_table = _resolveComponent("v-data-table");
    const _component_brg_pagination = _resolveComponent("brg-pagination");
    return (_openBlock(), _createElementBlock("div", null, [
        _createVNode(_component_v_data_table, {
            hover: "",
            class: "worker-baromoney-history-detail-dialog-table brg-table",
            "hide-default-footer": "",
            "fixed-header": "",
            density: "comfortable",
            headers: _ctx.workerBaromoneyHistoryDetailDialogTableHeader,
            "no-data-text": _ctx.noDataText,
            items: _ctx.workerBaromoneyHistoryDetailList,
            "items-per-page": -1,
            "sort-by": _ctx.sortBy,
            "onUpdate:sortBy": _ctx.handleUpdateSortBy
        }, {
            [`item.formattedWorkerBaromoneyMemo`]: _withCtx(({ item }) => [
                _createElementVNode("span", {
                    title: item.formattedWorkerBaromoneyMemo
                }, _toDisplayString(item.formattedWorkerBaromoneyMemo), 9 /* TEXT, PROPS */, _hoisted_1)
            ]),
            bottom: _withCtx(() => _cache[1] || (_cache[1] = [])),
            _: 2 /* DYNAMIC */
        }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["headers", "no-data-text", "items", "sort-by", "onUpdate:sortBy"]),
        _createVNode(_component_brg_pagination, {
            modelValue: _ctx.currentPage,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.currentPage) = $event)),
            "class-name": "mt-2 mb-n2",
            length: _ctx.paginationData.pages
        }, null, 8 /* PROPS */, ["modelValue", "length"])
    ]));
}
